module.exports = __webpack_public_path__ + "img/iconBussinessMaterialQuanlity.4e2f0257.svg";